import { observer } from "mobx-react"
import { VaultListFooterWrapper, VaultListFooterPagination, VaultListFooterPaginationButtonLeft, VaultListFooterPaginationButtonRight, VaultListFooterPaginationButtonIconWrapper } from "./VaultList.styles"
import { VaultPaginationIcon } from "../../assets/icons"
import { useStore } from "../../../app/data/root.store";
import { VaultTooltipsBar } from "../VaultTooltipsBar/VaultTooltipsBar";

export const VaultListFooter = observer(() => {
    const { vaultStore } = useStore();
    const { page, meta: { totalPages } } = vaultStore;

    const handlePageChange = (page) => {
        vaultStore.goToPage(page);
    }

    return (
        <VaultListFooterWrapper>
            {`${page} of ${totalPages} pages`}
            <VaultListFooterPagination>
                <VaultListFooterPaginationButtonLeft onClick={() => handlePageChange(page - 1)} disabled={(page === 1)}>
                    <VaultListFooterPaginationButtonIconWrapper disabled={(page === 1)}>
                        <VaultPaginationIcon />
                    </VaultListFooterPaginationButtonIconWrapper>
                </VaultListFooterPaginationButtonLeft>
                <VaultListFooterPaginationButtonRight onClick={() => handlePageChange(page + 1)} disabled={(page === totalPages)}>
                    <VaultListFooterPaginationButtonIconWrapper disabled={(page === totalPages)}>
                        <VaultPaginationIcon />
                    </VaultListFooterPaginationButtonIconWrapper>
                </VaultListFooterPaginationButtonRight>
            </VaultListFooterPagination>
            <VaultTooltipsBar position="footer" />
        </VaultListFooterWrapper>
    )
});